import assert from './asserts';

/**
 * 判断传入的参数是否是数组，是则返回参数本身，否则返回空数组
 * @param {any} operation 待转换参数
 */
const generatorArray = (operation) => (assert.isArray(operation) ? operation : []);
/**
 * 判断传入的参数是否是对象，是则返回参数本身，否则返回空对象
 * @param {any} operation 待转换参数
 */
const generatorObject = (operation) => (assert.isObject(operation) ? operation : {});
/**
 * 分页转换器
 * 将传入参数中的 current pageSize 转化为后端可识别的分页参数
 * @param {object} params 待转换参数
 */
const generatorPagination = (params) => {
  const { current = 1, pageSize = 10, ...rest } = params;
  // const limit = pageSize;
  // const offset = (current + 1) * limit;
  // return { offset, limit, ...rest };
  return { pageIndex: current, pageSize, ...rest };
};

export default {
  generatorArray,
  generatorObject,
  generatorPagination,
};
